<template>
  <el-dialog :title="form.id ? (form.editable ? '编辑进阶训练包' : '查看训练包详情') : '添加进阶训练包'" :visible.sync="dialogVisible"
    custom-class="no-padding" width="80%" :close-on-click-modal="false">
    <div class="advanced-contents" style="height:75vh" v-loading="loading">
      <div class="left">
        <el-form :model="form" :rules="rules" ref="form" label-width="130px" v-if="form.editable">
          <el-form-item label="进阶包名称：" prop="name" style="margin-bottom: 15px;">
            <el-input v-model="form.name" autocomplete="off" Z placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="所属分类：" prop="subjectCatalogueId" style="margin-bottom: 15px;" v-if="form.type == 1">
            <professional-tree :root="1" v-model="form.subjectCatalogueId"
              :config="{ 'checkStrictly': false }"></professional-tree>
          </el-form-item>
          <el-form-item label="进阶包封面：" prop="coverImgs" style="margin-bottom: 10px;">
            <card-upload :show-list="true" v-model="form.coverImgs" :limit="1" accept=".png,.jpg,.jpeg"
              :custom-style="{ 'width': '80', 'height': '60px', 'font-size': '22px', 'margin-bottom': '0px' }"></card-upload>
            <p class="item-trip">注：建议图片尺寸宽高比 = 4:3</p>
          </el-form-item>
          <div class="fx-box">
            <el-form-item label="每关题目数：" prop="testQuestionCount" style="margin-bottom: 10px;">
              <el-input-number :controls="false" v-model="form.testQuestionCount" :min="5" :max="50" size="small"
                placeholder="请输入" style="width:60px;"></el-input-number>
              <span class="color-777 font-12">说明：5~50题</span>
            </el-form-item>
            <el-form-item label="难度系数：" prop="difficulty" style="margin-bottom:5px;">
              <el-select v-model="form.difficulty" placeholder="请选择" class="text-center" style="width:60px" size="mini">
                <el-option v-for="item in 9" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item label="进阶考试次数：" prop="examCount" style="margin-bottom: 10px;">
            <el-input-number :controls="false" v-model="form.examCount" :min="1" :max="3" size="small" placeholder="请输入"
              style="width:60px;"></el-input-number>
            <span class="color-777 font-12">说明：1~3次</span>
          </el-form-item>
          <el-form-item label="进阶考试题量：" prop="examQuestionCount" style="margin-bottom: 0px;">
            <el-input-number :controls="false" v-model="form.examQuestionCount" :min="20" :max="50" size="small"
              placeholder="请输入" style="width:60px;"></el-input-number>
            <span class="color-777 font-12">说明：20~50题</span>
          </el-form-item>
          <div class="btns">
            <el-button type="primary" @click="submitForm" v-if="form.state <= 0">生成</el-button>
          </div>
        </el-form>
        <ul class="item-list" v-else style="padding:20px 30px">
          <li>
            <div class="keys">进阶包名称：</div>
            <div class="values">{{ form.name }}</div>
          </li>
          <li>
            <div class="keys">每关题目数：</div>
            <div class="values">{{ form.testQuestionCount }}</div>
          </li>
          <li>
            <div class="keys">难度系数：</div>
            <div class="values">{{ form.difficulty }}</div>
          </li>
          <li v-if="form.examCount > 0">
            <div class="keys">进阶考试次数：</div>
            <div class="values">{{ form.examCount }}</div>
          </li>
          <!-- <li v-if="form.examQuestionCount">
            <div class="keys">进阶考试题量：</div>
            <div class="values">{{ form.examQuestionCount }}</div>
          </li> -->
        </ul>
        <div class="guanqia">
          <el-collapse :accordion="true" v-model="collapseId">
            <el-collapse-item :name="item.id" v-for="item in packageList" :key="item.id">
              <template slot="title">
                <span class="order">第{{ item.sort }}阶</span>
                <span>{{ item.name }}</span>
                <div class="guanqia-right" @click.stop v-if="packageList.length > 1 && form.editable">
                  <el-popconfirm icon="el-icon-info" icon-color="red" title="确定删除此进阶吗？" @confirm="deleteLevel(item)">
                    <el-link type="danger" slot="reference" title="删除进阶"><i class="el-icon-delete"></i></el-link>
                  </el-popconfirm>
                </div>
              </template>
              <div class="guanqia-content">
                <div class="guanqia-item" @click="getQuestions(data)" :class="{ 'active': curentLevel.id == data.id }"
                  v-for="data in item.children" :key="data.id">
                  <span class="order" v-if="data.type !== 20">第{{ data.sort }}关</span>
                  <span class="order" v-else>进阶考试</span>
                  <span>{{ data.name }}</span>
                  <div class="guanqia-right" @click.stop v-if="data.type !== 20 && form.editable">
                    <el-popover placement="right" width="400" trigger="manual" popper-class="no-padding"
                      v-model="data.popperShow">
                      <div class="edit-level">
                        <div class="head">添加关卡</div>
                        <div class="body">
                          <el-form :model="levelForm" :rules="levelRules" ref="levelForm" label-width="80px"
                            v-if="data.popperShow">
                            <el-form-item label="关卡名称" prop="name">
                              <el-input v-model="levelForm.name" autocomplete="off" Z placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="选择章节" prop="curriculumChapterId">
                              <el-select v-model="levelForm.curriculumChapterId" placeholder="请选择">
                                <el-option v-for="item in chapters" :key="item.value" :label="item.name"
                                  :value="item.id"></el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label=" ">
                              <el-button @click="currentItem.popperShow = false">取消</el-button>
                              <el-button type="primary" @click="submitLevelForm" :loading="btnLoading">确定</el-button>
                            </el-form-item>
                          </el-form>
                        </div>
                      </div>
                      <el-link type="default" slot="reference" @click="showPopper(data, item)" title="添加关卡"><i
                          class="el-icon-plus"></i></el-link>
                    </el-popover>
                    <el-popconfirm icon="el-icon-info" icon-color="red" title="确定删除该关卡吗？"
                      @confirm="deleteLevel(data, item)">
                      <el-link type="danger" slot="reference" title="删除关卡"><i class="el-icon-delete"></i></el-link>
                    </el-popconfirm>
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <div class="right">
        <div class="info">
          <span><span class="mr-5" v-if="curentLevel.type == 20">进阶考试</span><span class="mr-5" v-else>第{{
            curentLevel.sort
            || 0 }}关</span>{{ curentLevel.name }}</span>
          <span class="ml-20">题目数量：{{ questions.length }}</span>
        </div>
        <div class="questions">
          <single-question :data="data" v-for="(data, index) in questions" :key="index" :index="index + 1" :is-edit="false">
            <template v-slot:edit>
              <el-button type="primary" plain size="mini" v-if="form.editable"
                @click="editQuestion('show', data)">换题</el-button>
            </template>
          </single-question>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false;">关闭</el-button>
      <el-button type="primary" @click="dialogVisible = false;">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  components: {
  },
  props: {
    value: "",
    trainingPackageId: "",
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      initForm: {
        "id": "",
        "name": "",
        "state": 0,
        "subjectCatalogueId": "",
        "difficulty": 3,
        "type": 1,
        "testQuestionCount": 9,
        "coverImgId": "",
        "coverImgUrl": "",
        "coverImgs": [],
        "examCount": 1,
        "examQuestionCount": 25,
      },
      form: {},
      packageList: [],
      curentLevel: {},
      questions: [],
    }
  },
  watch: {
    value(val) {
      this.dialogVisible = this.value;
    },
    dialogVisible(val) {
      if (val) {
        this.getTrainingPackageList(true);
        this.getDetails();
      } else {
        this.$emit('callback', 'hide');
      }
    },
  },
  created() {

  },
  mounted() {

  },
  methods: {
    getDetails() {
      let params = {
        id: this.trainingPackageId,
      }
      this.https("get", "/api/TrainingPackage/GetTrainingPackageById", params).then(res => {
        this.form = res.response || {};
        this.form.editable = false;
      })
    },
    getTrainingPackageList(init) {
      if (init) {
        this.questions = [];
        this.packageList = [];
      }
      let params = {
        trainingPackageId: this.trainingPackageId,
      }
      this.loading = true;
      this.https("get", "/api/TrainingPackage/GetTrainingPackageLevelTree", params).then(res => {
        this.loading = false;
        this.packageList = res.response.children || [];
        let stage = this.packageList.find(item => item.id == this.collapseId) || { id: "", children: [], };
        if (!stage.id && this.packageList.length > 0) {
          stage = this.packageList[0];
          this.collapseId = stage.id;
        }
        let level = stage.children.find(item => item.id == this.curentLevel.id) || {};
        if (!level.id && stage.children.length > 0) {
          this.curentLevel = stage.children[0];
        }
        this.getQuestions(this.curentLevel);
      }).catch(res => {
        this.loading = false;
      })
    },
    getQuestions(data) {
      if (!data.id) {
        return;
      }
      this.curentLevel = data;
      let params = {
        levelId: data.id,
      }
      this.loading = true;
      this.https("get", "/api/TrainingPackage/GetTrainingLevelQuestions", params).then(res => {
        this.loading = false;
        this.questions = res.response || [];
      }).catch(res => {
        this.loading = false;
      })
    },
  },
}
</script>
<style lang="scss">
.guanqia {
  .el-collapse-item__header {
    height: auto;
    line-height: 1.3;
    padding: 7px 25px 7px 0;
    border-bottom: 1px dashed #ddd;
    font-weight: bold;
    position: relative;

    // color: #000;
    &.is-active {
      color: #04adc0;
    }
  }

  .el-collapse-item__wrap {
    border-bottom: none;
  }
}
</style>
<style lang="scss" scoped>
.advanced-contents {
  display: flex;

  .left {
    flex: 3.5;
    display: flex;
    flex-direction: column;

    .el-form {
      padding: 20px 20px 15px;
      position: relative;

      .btns {
        position: absolute;
        right: 20px;
        bottom: 15px;

        .el-button {
          margin-left: 10px;
          min-width: 70px;
        }
      }
    }

    .guanqia {
      flex: 1;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
      padding: 15px 20px 20px 30px;
      overflow: auto;
      position: relative;

      .order {
        display: inline-block;
        vertical-align: middle;
        min-width: 45px;
        text-align-last: justify;
        text-justify: inter-ideograph;
        padding-right: 5px;
      }

      .guanqia-content {
        padding: 0 0 0 20px;
      }

      .guanqia-item {
        font-size: 14px;
        color: #333;
        border-bottom: 1px dashed #ddd;
        width: 100%;
        padding: 6px 60px 6px 10px;
        line-height: 1.3;
        position: relative;
        display: flex;

        &:hover {
          background-color: #f9f9f9;
          cursor: pointer;
        }

        &.active {
          background-color: #e8f8f8;
        }
      }
    }
  }

  .right {
    flex: 6.5;
    padding: 0 20px 20px;
    border-left: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    overflow: auto;
    display: flex;
    flex-direction: column;
    position: relative;

    .info {
      height: 40px;
      display: flex;
      align-items: center;
      font-size: 15px;
      font-weight: bold;
      background-color: #fff;
    }

    .questions {
      flex: 1;
      overflow: auto;
      border: 1px solid #eee;

      .change {
        font-size: 16px;

        // transform: rotate(-90deg);
        &:hover {
          cursor: pointer;
          color: #000;
        }
      }
    }
  }

  .guanqia-right {
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translate(0, -50%);

    .el-link {
      font-size: 15px;
    }
  }
}

.edit-level {
  padding: 0;

  .head {
    padding: 6px 10px;
    background-color: #04adc0;
    text-align: center;
    color: #fff;
    font-weight: bold;
    font-size: 15px;
  }

  .body {
    padding: 20px 20px 10px 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/pc/components/shared/AdvancedModal.vue